module.exports = __webpack_public_path__ + "static/2021-03-27-09-30-10-389-fs8-4f1f9c84f108382ca9e1965a79d7a1b6.png";